import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { EssenceBalance } from '@sorare/core/src/components/balance/EssenceBalance';
import { GemsBalance } from '@sorare/core/src/components/commonGame/GemsBalance';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { SUPPORTED_CARD_SETS } from '@sorare/core/src/lib/cardSets';
import { getCommonCardShardsCount } from '@sorare/core/src/lib/currentUser';

type Props = {
  cardSetSlugs?: string[];
};
export const SeriesBalance = ({
  cardSetSlugs = SUPPORTED_CARD_SETS,
}: Props) => {
  const {
    flags: { useEnableSeriesMarket = false },
  } = useFeatureFlags();

  const { currentUser } = useCurrentUserContext();
  const isSimplifiedNav = useSeriesNav();

  return (
    <Horizontal>
      {cardSetSlugs.map(
        slug =>
          ((slug === 'winter' && !!useEnableSeriesMarket) ||
            (slug === 'common-base-set' &&
              (!isSimplifiedNav || !useEnableSeriesMarket))) && (
            <EssenceBalance
              key={slug}
              value={getCommonCardShardsCount(currentUser, slug) || 0}
              rarity={Rarity.common}
              cardSetSlug={slug}
            />
          )
      )}
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
    </Horizontal>
  );
};
